///////////////////////////////////////////////////////////////////////////////////////////////////////////
// GLOBAL VARIABLES & STRUCTURES
///////////////////////////////////////////////////////////////////////////////////////////////////////////

const CONFIG = {};
const DATA = {};

// starting conditions
CONFIG.startzoom = 8;
CONFIG.minzoom   = CONFIG.startzoom;
CONFIG.maxzoom   = 17;
CONFIG.startlat  = 36.35495110643483;
CONFIG.startlng  = -121.0968017578125;

// Monterey County BBOX
CONFIG.bbox_w = -121.97838;
CONFIG.bbox_s = 35.78897;
CONFIG.bbox_e = -120.21397;
CONFIG.bbox_n = 36.91956;

// colors, styles and things
CONFIG.rcis_boundary_style = { fill: false, color: '#000000', opacity: 0.8, weight: 3 };

// first load, or not?
CONFIG.first_load = true;

// a container for a count of actions
CONFIG.actioncount = 0;

// how many results to display per "page"?
CONFIG.pagesize = 20;

// a list of action "targettypes" that get special handling
CONFIG.regional_actions = ['Water', 'Regional', 'Amphibian', 'Plant'];

// the style to use when drawing an area onto the map to request a report
// CONFIG.drawtool_edit_style is used while using the drawing tool to create a shape
// CONFIG.drawtool_draw_style displays your finished shape which you'll later submit for analysis
CONFIG.drawtool_edit_style = { color: '#0c2850', opacity: 0.75, dashArray: '10, 10', fill: true, fillColor: '#0c2850', fillOpacity: 0.1, clickable: false };
CONFIG.drawtool_draw_style = { color: '#0c2850', opacity: 0.75, weight: 4, fillColor:'#0c2850', fillOpacity: 0.1, clickable: false };

// map search endpoints
const mapsearch_baseurl = IS_DEVO ? "http://www.montereycountyrcis.org:9000" : "https://www.montereycountyrcis.org";
CONFIG.mapsearch_upload = `${mapsearch_baseurl}/process/upload/`;
CONFIG.mapsearch_geojson = `${mapsearch_baseurl}/process/geojson/`;

// a placeholder for mapsearch results
CONFIG.mapsearch_result = null;

///////////////////////////////////////////////////////////////////////////////////////////////////////////
// INITIALIZATION: these functions are called when the page is ready,
///////////////////////////////////////////////////////////////////////////////////////////////////////////
$(document).ready(function() {
    initTabs();
    initActionPanelsAndChoices();
    initSpeciesPanelsAndChoices();
    initAppFromURLParams();

    Promise.all([
            // get static data files
            initData('./data/species/all'),
            initData(`${BASEURL}/static/data/rcis_boundary.json`),
        ]).then(function(data) {
            initDataFormat(data); // data formatting, manipulation
            initMaps();
            initSpeciesMapTools();
            initActionMapTools();
            initSpeciesSearch(DATA.specieslist);

            // trigger the default species and action searches
            updateSpeciesResults(DATA.specieslist);
            paginateActionResults(DATA.actionlist);
        
            // ready!
            // a series of hacks to make it all okay:
            $(window).scrollTop(0); // if we're coming here from a hash URL, the window will scroll to that div. Don't do that
            $('div#loading').hide(); // and hide the loader
            
            // finally
            $(window).trigger('resize');
            CONFIG.first_load = false;

        });
});


$(window).on('resize', function() {
    // wait for the maps to come into being, and when they do, make the map fit
    waitForIt(CONFIG.species_map, function() { CONFIG.species_map.invalidateSize(); });
    waitForIt(CONFIG.action_map, function() { CONFIG.action_map.invalidateSize(); });

    // that's all. anything else here need resizing? 

})


///////////////////////////////////////////////////////////////////////////////////////////////////////////
// Functions called on doc ready
///////////////////////////////////////////////////////////////////////////////////////////////////////////

// Generic data init, returns a promise
function initData(url) {
    // get the data
    // wrap this in a promise, so we know we have it before continuing on to remaining initialize steps
    return new Promise(function(resolve, reject) {
        $.get(url, function(data) {
            resolve(data);
        });
    });
}


// data formatting functions
function initDataFormat(data) {
    // save a reference to the species data
    DATA.specieslist = data[0]['species'];

    // keep a reference to the total count of actions and species
    CONFIG.speciescount = DATA.specieslist.length;
    CONFIG.actioncount = data[0].actioncount;

    // rework the specieslist into a list of every action
    // also update the targettype for regional action types
    DATA.actionlist = [];
    DATA.specieslist.forEach(function(species) {
        species['actions'].forEach(function(action) {
            DATA.actionlist.push(action);
        });
    });

    // keep a reference to the RCIS boundary
    DATA.rcis_boundary_raw = data[1];
}

// check for URL params, and if present, apply them
function initAppFromURLParams() {
    // if we have params, then parse them
    if (window.location.search) {
        // check for URL params and set filters as appropriate
        let params = new URLSearchParams(window.location.search);
        parseURLParams(params);
    }

    // there's really no else condition here, yet...
}


// we pass a hash to indicate whether to show the Action or the Species tab
function initTabs() {
    // update the URL hash to match the selected tab, when one is selected
    $('div.tabs a.nav-link').on('shown.bs.tab', function() {
        // reset the maps, now that they are visible
        waitForIt(CONFIG.species_map, function() { CONFIG.species_map.invalidateSize(); });
        waitForIt(CONFIG.action_map, function() { CONFIG.action_map.invalidateSize(); });

        // update URL params
        composeURLParams();
    });
}

// init the dropdowns for the species search. At the moment there is only one
function initSpeciesPanelsAndChoices() {

    // init the close buttons on the panels
    $('ul#species-filters li.species-choice-toggle button.btn-close').on('click', function() {
        $(this).closest('li.species-choice-toggle').click();
    });

    // init the dropdowns
    $('ul#species-filters li.species-choice-toggle').on('click', function(e) {
        // if we actually clicked on a panel item (which is a child of the <li>), don't do anything
        if ($(e.target).closest('div.species-choice-panels, div.form-check').length == 1 ) {
            return; 
        }
        // otherwise carry on... 
        // close any open panels
        $('div.species-choice-panels').hide(); 
        // revert all the chevrons
        $('a.species-choice-link i.fas').removeClass('fa-chevron-down').addClass('fa-chevron-right');
        // reset the closed class, for any open panels not this
        $('ul#species-filters li.species-choice-toggle').not(this).removeClass('open').addClass('closed');

        // button == this
        let button = $(this);

        // toggle the panel and the button's chevron
        let chevron = button.find('a i.fas');
        let panel = button.find('div.species-choice-panels');
        if (button.hasClass('closed')) {
            button.removeClass('closed').addClass('open')
            chevron.removeClass('fa-chevron-right').addClass('fa-chevron-down');
            panel.show();
        } else {
            button.removeClass('open').addClass('closed');
            chevron.addClass('fa-chevron-right').removeClass('fa-chevron-down');
            panel.hide();
        }
    });

    // background clicks will close the panels, and reset the chevrons
    $('html').click(function(event) {
        let target_list = 'div#species-map, ul#species-filters, li.species-choice-toggle, a.species-choice-link, div.species-choice-panels, input.action-checkbox, label.action-checkbox-label';
        if ($(event.target).closest(target_list).length === 0) {
            // close the panels
            $('div.species-choice-panels').hide(); 
            // revert all the chevrons
            $('a.species-choice-link i.fas').removeClass('fa-chevron-down').addClass('fa-chevron-right');
            // reset the closed class, for any open panels not this
            $('ul#species-filters li.species-choice-toggle').not(this).removeClass('open').addClass('closed');
        }
    });
}


// init the dropdowns and checkboxes for the action choice panels on the Actions tab
function initActionPanelsAndChoices() {
    // init the 'Get Actions' button to submit the action search
    $('button.btn-get-action').on('click', function() {
        // call the function that does it all
        doActionSearch(); 
    });

    // init the "All" button
    $('ul.action-filters li a#toggle-all').on('click', function() {
        let button = $(this);
        if (button.hasClass('selected')) {
            button.removeClass('selected');
            // uncheck all the checkboxes
            $('ul.action-filters li.action-choice-toggle input[type="checkbox"]').prop('checked', false);
        } else {
            button.addClass('selected');
            // check all the checkboxes
            $('ul.action-filters li.action-choice-toggle input[type="checkbox"]').prop('checked', true);
        };
    });

    // init the close buttons on the panels
    $('ul.action-filters li.action-choice-toggle button.btn-close').on('click', function() {
        $(this).closest('li.action-choice-toggle').click();
    });

    // init the dropdowns
    $('ul.action-filters li.action-choice-toggle').on('click', function(e) {
        // if we actually clicked on a panel item (which is a child of the <li>), don't do anything
        if ($(e.target).closest('div.action-choice-panels, div.form-check').length == 1 ) {
            return; 
        }
        // otherwise carry on... 
        // close any open panels
        $('div.action-choice-panels').hide(); 
        // revert all the chevrons
        $('a.action-choice-link i.fas').removeClass('fa-chevron-down').addClass('fa-chevron-right');
        // reset the closed class, for any open panels not this
        $('ul.action-filters li.action-choice-toggle').not(this).removeClass('open').addClass('closed');

        // button == this
        let button = $(this);

        // toggle the panel and the button's chevron
        let chevron = button.find('a i.fas');
        let panel = button.find('div.action-choice-panels');
        if (button.hasClass('closed')) {
            button.removeClass('closed').addClass('open')
            chevron.removeClass('fa-chevron-right').addClass('fa-chevron-down');
            panel.show();
        } else {
            button.removeClass('open').addClass('closed');
            chevron.addClass('fa-chevron-right').removeClass('fa-chevron-down');
            panel.hide();
        }
    });

    // init the following "special" checkboxes which enable groups to toggle "all/none" 
    $('ul.action-filters li.action-choice-toggle input[type="checkbox"].all-actions').on('change', function() {
        let checkbox = $(this);
        let value = checkbox.val();
        let checked = checkbox.is(':checked');

        switch(value) {
            case 'all-wildlife':
                $('ul.action-filters li.action-choice-toggle input[type="checkbox"].wildlife').prop('checked', checked);
                break;

            case 'all-plant':
                $('ul.action-filters li.action-choice-toggle input[type="checkbox"].plant').prop('checked', checked);
                break;          
        
            case 'all-amphibian':
                $('ul.action-filters li.action-choice-toggle input[type="checkbox"].amphibian').prop('checked', checked);
                break;  
        }
    });

    // background clicks will close the panels, and reset the chevrons
    $('html').click(function(event) {
        let target_list = 'div#action-map, ul.action-filters, li.action-choice-toggle, a.action-choice-link, div.action-choice-panels, input.action-checkbox, label.action-checkbox-label';
        if ($(event.target).closest(target_list).length === 0) {
            // close the panels
            $('div.action-choice-panels').hide(); 
            // revert all the chevrons
            $('a.action-choice-link i.fas').removeClass('fa-chevron-down').addClass('fa-chevron-right');
            // reset the closed class, for any open panels not this
            $('ul.action-filters li.action-choice-toggle').not(this).removeClass('open').addClass('closed');
        }
    });
}

// init the search and autocomplete behavior after fetching a list of terms
function initSpeciesSearch(specieslist) {       
    // set up the select options from data
    let select = $('#species-search'); 
    specieslist.sort(function(a, b) {
        return a.commonname > b.commonname ? 1 : a.commonname < b.commonname ? -1 : 0;
    }).forEach(function(d) {
        let text = d.latinname ? `${d.commonname} (${d.latinname})` : `${d.commonname}`;
        $('<option>', {
            value: d.id,
            'data-key': d.key,
            text: text,
        }).appendTo(select);
    });

    // render the select using select2
    select.select2({
        placeholder: select.attr('placeholder'),
        closeOnSelect: true,
    });

    // Set up an event listener on the "submit" button to trigger a species search 
    $('button.btn-get-species').on('click', function() {
        let selected = $('#species-search').val();
        let subset = DATA.specieslist.filter(function(d) {
            return d.id == selected;
        });

        // remove/null any map search, per #91
        CONFIG.mapsearch_result = null;
        $('div.species-choice-panels div.map-filter-button-wrapper button.btn-cancel').click();
        CONFIG.species_map.fitBounds([[CONFIG.bbox_n, CONFIG.bbox_e], [CONFIG.bbox_s, CONFIG.bbox_w]]);

        // update the results
        updateSpeciesResults(subset);
        updateSpeciesSearchPills();
    });
}

// we have two maps here, one on the Action tab, one on the Species tab
function initMaps() {
    // basemap definitions for both maps
    const basemaps = [
        {
            type:'xyz',
            label:'photo',
            maxZoom: CONFIG.maxzoom,
            minZoom: CONFIG.minzoom,
            url:'http://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
            attrib:'Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community',
            tooltip:'Satellite + aerial photo basemap by ESRI'
        },
        {
            type:'xyz',
            label:'map',
            maxZoom: CONFIG.maxzoom,
            minZoom: CONFIG.minzoom,
            url:'https://{s}.basemaps.cartocdn.com/light_nolabels/{z}/{x}/{y}' + (L.Browser.retina ? '@2x.png' : '.png'),
            attrib:'Map tiles by <a target="_blank" href="http://www.mapbox.com">MapBox</a>.<br />Data &copy; <a target="_blank" href="http://openstreetmap.org/copyright" target="_blank">OpenStreetMap contributings</a>',
            tooltip:'Plain grey map with Open Street Map data'
        },
    ];

    //
    // SPECIES MAP
    // 
    CONFIG.species_map = L.map('species-map', {
        minZoom: CONFIG.minzoom,
        maxZoom: CONFIG.maxzoom,
        attributionControl: false,
        zoomControl: false,
        scrollWheelZoom: false,
    }).fitBounds([[CONFIG.bbox_n, CONFIG.bbox_e], [CONFIG.bbox_s, CONFIG.bbox_w]]);

    // add the basemapbar
    new L.Control.BasemapBar({
        layers: basemaps,
        position: 'topleft'
    }).addTo(CONFIG.species_map).selectLayer('map');

    // add the custom zoom home control
    new L.Control.ZoomBar({
        position: 'topleft',
        homeLatLng: [CONFIG.startlat, CONFIG.startlng],
        homeZoom: CONFIG.startzoom,
    }).addTo(CONFIG.species_map);

    // add the RCIS boundary to the map
    DATA.rcis_boundary = L.geoJSON(DATA.rcis_boundary_raw, { style: CONFIG.rcis_boundary_style } ).addTo(CONFIG.species_map);

    // add the basemap _with_ labels, always on
    L.tileLayer('https://{s}.basemaps.cartocdn.com/light_only_labels/{z}/{x}/{y}' + (L.Browser.retina ? '@2x.png' : '.png'), {
        attribution:'&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, &copy; <a href="https://carto.com/attributions">CARTO</a>',
        maxZoom: CONFIG.maxzoom,
        minZoom: CONFIG.minzoom,
        subdomains: 'abcd',
        zIndex: 999,
     }).addTo(CONFIG.species_map);

    //
    // ACTION MAP
    //
    CONFIG.action_map = L.map('action-map', {
        minZoom: CONFIG.minzoom,
        maxZoom: CONFIG.maxzoom,
        attributionControl: false,
        zoomControl: false,
        scrollWheelZoom: false,
    }).fitBounds([[CONFIG.bbox_n, CONFIG.bbox_e], [CONFIG.bbox_s, CONFIG.bbox_w]])

    // add the basemapbar
    new L.Control.BasemapBar({
        layers: basemaps,
        position: 'topleft'
    }).addTo(CONFIG.action_map).selectLayer('map');

    // add the custom zoom home control
    new L.Control.ZoomBar({
        position: 'topleft',
        homeLatLng: [CONFIG.startlat, CONFIG.startlng],
        homeZoom: CONFIG.startzoom,
    }).addTo(CONFIG.action_map);

    // add the RCIS boundary to the map
    DATA.rcis_boundary = L.geoJSON(DATA.rcis_boundary_raw, { style: CONFIG.rcis_boundary_style } ).addTo(CONFIG.action_map);

    // add the basemap _with_ labels, always on
    L.tileLayer('https://{s}.basemaps.cartocdn.com/light_only_labels/{z}/{x}/{y}' + (L.Browser.retina ? '@2x.png' : '.png'), {
        attribution:'&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, &copy; <a href="https://carto.com/attributions">CARTO</a>',
        maxZoom: CONFIG.maxzoom,
        minZoom: CONFIG.minzoom,
        subdomains: 'abcd',
     }).addTo(CONFIG.action_map);


    CONFIG.species_map.invalidateSize();
    CONFIG.action_map.invalidateSize();

}

// Species map drawing tools:
// those these are largely the same as the species map tools,
// they are repeated here in case they do need to diverge
function initSpeciesMapTools() {
    // initialize some vars used throughout
    const drawbutton        = $('div.species-choice-panels div.map-tools-wrapper div.draw button');
    const uploadform        = $('div.species-choice-panels div.map-tools-wrapper form');
    const uploadbutton      = $('div.species-choice-panels div.map-tools-wrapper div.upload button'); 
    const uploadinput       = $('div.species-choice-panels div.map-tools-wrapper form input');
    const applybutton       = $('div.species-choice-panels div.map-filter-button-wrapper button.btn-apply');
    const cancelbutton      = $('div.species-choice-panels div.map-filter-button-wrapper button.btn-cancel');
    const attached_file_msg = $('div#species-file-attached-msg');

    // trigger the polygon draw tool 
    drawbutton.on('click', function() {
        // always stop and reset the tool, even if we're becoming selected
        CONFIG.species_map.drawarea.drawtool.disable();  

        // disable clear and apply
        cancelbutton.prop('disabled', true);
        applybutton.prop('disabled', true);

        $('div.species-choice-panels div.map-tools-wrapper button').not(this).removeClass('active');
        if (drawbutton.hasClass('active')) {
            drawbutton.removeClass('active');
        } else {
            drawbutton.addClass('active');
            attached_file_msg.hide();
            CONFIG.species_map.drawarea.drawings.clearLayers();
            CONFIG.species_map.drawarea.drawtool.enable();
        }
    });

    // trigger the upload dialog, which is actually driven by a hidden file input
    uploadbutton.on('click', function() {
        // stop the Draw tool and sync the button states
        CONFIG.species_map.drawarea.drawtool.disable();  
        CONFIG.species_map.drawarea.drawings.clearLayers();
        cancelbutton.prop('disabled', true); // disable the cancel button
        applybutton.prop('disabled', true);  // disable the apply button
        $('div.species-choice-panels div.map-tools-wrapper button').not(this).removeClass('active');

        if (uploadbutton.hasClass('active')) {
            $('div#file-attached-msg').hide();   // hide the file message
            uploadbutton.removeClass('active');  // reset button state
        } else {
            uploadbutton.addClass('active');
            CONFIG.species_map.drawarea.drawings.clearLayers();
            // trigger the file dialog, clearing any existing attached upload
            let fileinput = uploadbutton.siblings('form').find('input').val('').click();
            fileinput.on('change', function() {
                cancelbutton.prop('disabled', false); // enable the cancel button
                applybutton.prop('disabled', false);  // enable the apply button

                // process the filename for the message
                let filepath = $(this).val();
                var filename = filepath.replace(/^.*?([^\\\/]*)$/, '$1');
                attached_file_msg.show().find('span').text(filename);
            });
        }
    });

    // init the cancel button
    cancelbutton.on('click', function() {
        // clear any drawing
        CONFIG.species_map.drawarea.drawings.clearLayers();

        // clear any file upload
        uploadinput.val('');
        attached_file_msg.hide();

        // reset button state for all buttons
        $('div.species-choice-panels div.map-tools-wrapper button').removeClass('active');

        // re-disable the buttons for next time
        cancelbutton.prop('disabled', true);
        applybutton.prop('disabled', true);
    });

    //
    // Draw polygon initialization
    //
    L.drawLocal.draw.handlers.polygon.tooltip.start  = 'Click to draw an area. Double-click to finish.';
    L.drawLocal.draw.handlers.polygon.tooltip.cont   = 'Double-click to finish.';
    L.drawLocal.draw.handlers.polygon.tooltip.end    = 'Double-click to finish.';

    CONFIG.species_map.drawarea = {};
    CONFIG.species_map.drawarea.drawings      = new L.FeatureGroup([]).addTo(CONFIG.species_map);
    CONFIG.species_map.drawarea.control       = new L.Control.Draw({ draw: false, edit: false, remove: false, featureGroup: CONFIG.species_map.drawarea.drawings, selectedPathOptions: CONFIG.drawtool_edit_style }).addTo(CONFIG.species_map);
    CONFIG.species_map.drawarea.drawtool      = new L.Draw.Polygon(CONFIG.species_map,  { repeatMode:true, allowIntersection:false, metric:false, shapeOptions: CONFIG.drawtool_draw_style});

    CONFIG.species_map.on(L.Draw.Event.CREATED, function (event) {
        // clear any prior drawing, then add this one to the layer which we could submit for analysis
        CONFIG.species_map.drawarea.drawings.clearLayers();
        CONFIG.species_map.drawarea.drawings.addLayer(event.layer);

        cancelbutton.prop('disabled', false); // enable the apply button
        applybutton.prop('disabled', false);  // enable the apply button
    });

    // init the upload form using ajaxForm
    uploadform.ajaxForm({
        type: 'POST',
        url: CONFIG.mapsearch_upload,
        dataType: 'json',
        clearForm: true,
        beforeSerialize: function ($form) {
            if (! uploadinput.val()) return false;
            return true;
        },
        beforeSubmit: function () {
            $('div#loading').show();
        },
        success: function (response, statusText, xhr, $form) {
            uploadinput.val('');

            // save a reference to the repsonse
            // at the moment, this is only used to know what so say in "area searched"
            if (response.targets.length > 0) {
                CONFIG.mapsearch_result = response.targets;
            } else {
                // 'nothing' will never intersect with our checkboxes, so always return, well, nothing
                CONFIG.mapsearch_result = null;
            }

            // filter the raw species data down to this matching list
            let specieslist = DATA.specieslist.filter(function(d) {
                return response.targets.indexOf(d.key) > -1;
            });
            
            // and update the search
            updateSpeciesResults(specieslist);

            // add the returned geojson (will be identical to their upload) to the map
            // and fit the map to that polygon
            let layer = L.geoJSON(response.geojson);
            layer.setStyle(CONFIG.drawtool_draw_style);
            CONFIG.species_map.drawarea.drawings.addLayer(layer);
            CONFIG.species_map.fitBounds(layer.getBounds());
            
            // awl set
            $('div#loading').hide();
        },
        error: function (xhr) {
            uploadinput.val('');
            $('div#loading').hide();
            const errortext = xhr.responseText ? xhr.responseText : "There was a problem connecting to the server to perform the analysis. Please try again.";
            alert(errortext);  // the endpoints do return meaningful error messages
        },
    });

    // init the "apply" button for both types of polygon: drawn and uploaded
    // TO DO: integrate this with the "Get Species" button ??
    applybutton.on('click', function() {
        let activebutton = $('div.species-choice-panels div.map-tools-wrapper button.active').parent('div');

        // always clear any single species selection from the dropdown, per #91
        $('#species-search').val('').trigger('change');

        // Case 1: The Upload button is active, submit the upload
        if (activebutton.hasClass('upload')) {
            if (! uploadinput.val()) return false;
            // trigger the form submit. See ajaxForm definition above for resulting behavior
            uploadform.submit();
        } // submit upload

        // Case 2: The Draw button is active, submit the drawing
        if (activebutton.hasClass('draw')) {
            // if there's no drawing, return
            let drawing = CONFIG.species_map.drawarea.drawings.getLayers();
            if (! drawing.length) return false;

            // stringify the drawing, and hand it off to get intersecting targets
            const params = {
                geojson: JSON.stringify(drawing[0].toGeoJSON()),
            };

            $('div#loading').show();

            jQuery.post(CONFIG.mapsearch_geojson, params, function (response) {
                // save a reference to the repsonse
                // at the moment, this is only used to know what so say in "area searched"
                if (response.targets.length > 0) {
                    CONFIG.mapsearch_result = response.targets;
                } else {
                    // 'nothing' will never intersect with our checkboxes, so always return, well, nothing
                    CONFIG.mapsearch_result = null;
                }

                // filter the raw species data down to this matching list
                let specieslist = DATA.specieslist.filter(function(d) {
                    return response.targets.indexOf(d.key) > -1;
                });
                
                // and update the search
                updateSpeciesResults(specieslist);

            }, 'json')
            .fail(function (xhr) {
                const errortext = xhr.responseText ? xhr.responseText : "There was a problem connecting to the server to perform the analysis. Please try again.";
                alert(errortext);  // the endpoints do return meaningful error messages
            })
            .always(function () {
                $('div#loading').hide();
            });
        } // submit drawing
    });
}


// Action map drawing tools:
// those these are largely the same as the species map tools,
// they are repeated here because they do in fact diverge
function initActionMapTools() {
    // initialize some constants used throughout
    const drawbutton        = $('div.action-choice-panels div.map-tools-wrapper div.draw button');
    const uploadform        = $('div.action-choice-panels div.map-tools-wrapper form');
    const uploadbutton      = $('div.action-choice-panels div.map-tools-wrapper div.upload button'); 
    const uploadinput       = $('div.action-choice-panels div.map-tools-wrapper form input');
    const applybutton       = $('div.action-choice-panels div.map-filter-button-wrapper button.btn-apply');
    const cancelbutton      = $('div.action-choice-panels div.map-filter-button-wrapper button.btn-cancel');
    const attached_file_msg = $('div#action-file-attached-msg');

    // initialize L.Draw itself
    L.drawLocal.draw.handlers.polygon.tooltip.start  = 'Click to draw an area. Double-click to finish.';
    L.drawLocal.draw.handlers.polygon.tooltip.cont   = 'Double-click to finish.';
    L.drawLocal.draw.handlers.polygon.tooltip.end    = 'Double-click to finish.';

    CONFIG.action_map.drawarea = {};
    CONFIG.action_map.drawarea.drawings      = new L.FeatureGroup([]).addTo(CONFIG.action_map);
    CONFIG.action_map.drawarea.control       = new L.Control.Draw({ draw: false, edit: false, remove: false, featureGroup: CONFIG.action_map.drawarea.drawings, selectedPathOptions: CONFIG.drawtool_edit_style }).addTo(CONFIG.action_map);
    CONFIG.action_map.drawarea.drawtool      = new L.Draw.Polygon(CONFIG.action_map,  { repeatMode:true, allowIntersection:false, metric:false, shapeOptions: CONFIG.drawtool_draw_style});

    CONFIG.action_map.on(L.Draw.Event.CREATED, function (event) {
        // clear any prior drawing, then add this one to the layer which we could submit for analysis
        CONFIG.action_map.drawarea.drawings.clearLayers();
        CONFIG.action_map.drawarea.drawings.addLayer(event.layer);

        cancelbutton.prop('disabled', false); // enable the cancel button
        applybutton.prop('disabled', false);  // enable the apply button
    });

    // init the polygon draw button
    drawbutton.on('click', function() {
        // always stop and reset the tool, even if we're becoming selected
        CONFIG.action_map.drawarea.drawtool.disable();  

        // disable clear and apply
        cancelbutton.prop('disabled', true);
        applybutton.prop('disabled', true);

        $('div.action-choice-panels div.map-tools-wrapper button').not(this).removeClass('active');
        if (drawbutton.hasClass('active')) {
            drawbutton.removeClass('active'); 
        } else {
            drawbutton.addClass('active'); 
            attached_file_msg.hide();
            CONFIG.action_map.drawarea.drawings.clearLayers();
            CONFIG.action_map.drawarea.drawtool.enable();
        }
    });

    // init the cancel button
    cancelbutton.on('click', function() {
        // clear any drawing
        CONFIG.action_map.drawarea.drawings.clearLayers();

        // clear any file upload
        uploadinput.val('');
        attached_file_msg.hide();

        // reset button state for all buttons
        $('div.action-choice-panels div.map-tools-wrapper button').removeClass('active');

        // re-disable the buttons for next time
        cancelbutton.prop('disabled', true);
        applybutton.prop('disabled', true);
    });

    // init the upload dialog, which is actually driven by a hidden file input
    uploadbutton.on('click', function() {
        // stop the Draw tool and sync the button states
        CONFIG.action_map.drawarea.drawtool.disable();  
        CONFIG.action_map.drawarea.drawings.clearLayers();
        cancelbutton.prop('disabled', true); // disable the cancel button
        applybutton.prop('disabled', true);  // disable the apply button
        $('div.action-choice-panels div.map-tools-wrapper button').not(this).removeClass('active');

        if (uploadbutton.hasClass('active')) {
            $('div#file-attached-msg').hide();   // hide the file message
            uploadbutton.removeClass('active');  // reset button state
        } else {
            uploadbutton.addClass('active'); // reset button state
            CONFIG.action_map.drawarea.drawings.clearLayers();
            // trigger the file dialog, clearing any existing attached upload
            let fileinput = uploadbutton.siblings('form').find('input').val('').click();
            fileinput.on('change', function() {
                cancelbutton.prop('disabled', false); // enable the cancel button
                applybutton.prop('disabled', false);  // enable the apply button

                // process the filename for the message
                let filepath = $(this).val();
                var filename = filepath.replace(/^.*?([^\\\/]*)$/, '$1');
                attached_file_msg.show().find('span').text(filename);
            });
        }
    });

    // init the upload form itself using ajaxForm
    uploadform.ajaxForm({
        type: 'POST',
        url: CONFIG.mapsearch_upload,
        dataType: 'json',
        clearForm: true,
        beforeSerialize: function ($form) {
            if (! uploadinput.val()) return false;
            return true;
        },
        beforeSubmit: function () {
            $('div#loading').show();
        },
        success: function (response, statusText, xhr, $form) {
            uploadinput.val(''); // clear the file input

            // save a reference to the repsonse
            if (response.targets.length > 0) {
                CONFIG.mapsearch_result = response.targets;
            } else {
                // 'nothing' will never intersect with our checkboxes, so always return, well, nothing
                CONFIG.mapsearch_result = null;
            }

            // add the returned geojson (will be identical to their upload) to the map
            // and fit the map to this layer
            let layer = L.geoJSON(response.geojson);
            layer.setStyle(CONFIG.drawtool_draw_style);
            CONFIG.action_map.drawarea.drawings.addLayer(layer);
            CONFIG.action_map.fitBounds(layer.getBounds());

            // call the function to filter and update the results based on this response
            doActionSearch()
            
            // awl set
            $('div#loading').hide();
        },
        error: function (xhr) {
            uploadinput.val('');
            $('div#loading').hide();
            const errortext = xhr.responseText ? xhr.responseText : "There was a problem connecting to the server to perform the analysis. Please try again.";
            alert(errortext);  // the endpoints do return meaningful error messages
        },
    });

    // init the "apply" button for both types of polygon: drawn and uploaded
    applybutton.on('click', function() {
        let activebutton = $('div.action-choice-panels div.map-tools-wrapper button.active').parent('div');

        // Case 1: The Upload button is active, submit the upload
        if (activebutton.hasClass('upload')) {
            if (! uploadinput.val()) return false;
            // trigger the form submit. See ajaxForm definition above for resulting behavior
            uploadform.submit();
        } // submit upload

        // Case 2: The Draw button is active, submit the drawing
        if (activebutton.hasClass('draw')) {
            // if there's no drawing, return
            let drawing = CONFIG.action_map.drawarea.drawings.getLayers();
            if (! drawing.length) return false;

            // stringify the drawing, and hand it off to get intersecting targets
            const params = {
                geojson: JSON.stringify(drawing[0].toGeoJSON()),
            };

            $('div#loading').show();

            jQuery.post(CONFIG.mapsearch_geojson, params, function (response) {
                console.log(response);

                // before anything, save a reference to the repsonse
                if (response.targets.length > 0) {
                    CONFIG.mapsearch_result = response.targets;
                } else {
                    // 'nothing' will never intersect with our checkboxes, so always return, well, nothing
                    CONFIG.mapsearch_result = null;
                }

                doActionSearch();

            }, 'json')
            .fail(function (xhr) {
                const errortext = xhr.responseText ? xhr.responseText : "There was a problem connecting to the server to perform the analysis. Please try again.";
                alert(errortext);  // the endpoints do return meaningful error messages
            })
            .always(function () {
                $('div#loading').hide();
            });
        } // submit drawing
    });
}



///////////////////////////////////////////////////////////////////////////////////////////////////////////
// Named functions 
///////////////////////////////////////////////////////////////////////////////////////////////////////////

// parse URL parms
function parseURLParams(params) {
    // set selected tab
    if (params.has('tab')) {
        let tab = params.get('tab');
        $(`div.tabs a.nav-link[data-target="#${tab}"]`).click();
    }
}

// compose URL params
function composeURLParams() {
  // get the current search params
  let params = new URLSearchParams(window.location.search);

  // set a param for the selected tab
  params.delete('tab');
  let tab = $('div.tabs a.nav-link.active').data().target.replace('#','');
  params.append('tab', tab);

  // all set! if we have anything, parse the string, make it a query and
  // replace state in our local address bar
  let searchstring = decodeURIComponent(params.toString());
  if (searchstring) {
    var newparams = '?' + searchstring;
    window.history.replaceState(newparams, '', newparams);
  }
}

// update results for species
function updateSpeciesResults(specieslist) {
    let target = $('div#focal-species-cards').empty();

    // iterate the list and create a focal species "card" for each
    specieslist.forEach(function(d) {
        let card = $('<div>', {
            'class': 'card-outer',
        }).appendTo(target);

        let cardlink = $('<a>', {
            'class': 'focalcard-link',
            href: `${BASEURL}/species/${d.key}`,
        }).appendTo(card);

        let textwrapper = $('<div>', {
            'class': 'card-text-wrapper'
        }).appendTo(cardlink);

        $('<div>', {
            'class': 'species-type-pill',
            text: d.targettype,
        }).appendTo(textwrapper);

        $('<div>', {
            'class': 'species-commonname',
            text: d.commonname,
        }).appendTo(textwrapper);

        $('<div>', {
            'class': 'species-latinname',
            text: d.latinname,
        }).appendTo(textwrapper);

        // not everything has a priority listed, e.g. HC
        if (d.priority) {
            $('<div>', {
                'class': 'species-priority',
                html: `RCIS Conservation Priority &#8226; <span class="priority ${d.priority}">${d.priority}</span>`,
            }).appendTo(textwrapper);
        }

        // almost all have an image, but not all
        if (d.image) {
            $('<img>', {
                src: `/static/images/focal-photos-thumbs/${d.image}`,
                'class': 'focal-thumb',
            }).appendTo(cardlink);
        }
    });

    // second step: iterate the list again, to create the set of related species that will be listed in the bottom section
    // this list has overlaps, so first create a unique set of related species
    let relatedspecies_all = [];
    specieslist.forEach(function(d) {
        d.relatedspecies.forEach(function(r) {
            relatedspecies_all.push(r);
        })
    })
    // get only the unique ones, by the property "key"
    let relatedspecies = uniqueObjects(relatedspecies_all, 'key');

    // now iterate and create the cards
    let targetdiv = $('div#non-focal-species-cards').empty();
    let rowtarget;
    relatedspecies.forEach(function(d, i) {

        // every three items, we create a new outer target
        if (i % 3 == 0) {
            rowtarget = $('<div>', {
                'class': 'row no-gutters',
            }).appendTo(targetdiv);
        }
        
        let card = $('<div>', {
            'class': 'col-md-4 nonfocal-outer',
        }).appendTo(rowtarget);

        let innercard = $('<div>', {
            'class': 'nonfocal-card',
        }).appendTo(card);

        let textwrapper = $('<div>', {
            'class': 'card-text-wrapper'
        }).appendTo(innercard);

        $('<div>', {
            'class': 'species-type-pill',
            text: d.targettype,
        }).appendTo(textwrapper);

        $('<div>', {
            'class': 'species-commonname',
            text: d.commonname,
        }).appendTo(textwrapper);

        $('<div>', {
            'class': 'species-latinname',
            text: d.latinname,
        }).appendTo(textwrapper);

        $('<div>', {
            'class': 'species-status',
            html: `Status &#8226; <span class="status">${d.status.join(', ')}</span>`,
        }).appendTo(textwrapper);

        let relateds = [];
        d.parents.forEach(function(p) {
            // TODO: some kind of URL to a species page needed here
            relateds.push(`<a href="${p.key}">${p.commonname}</a>`);
        });

        $('<div>', {
            'class': 'related-focals',
            html: `Related focal species &#8226; ${relateds.join(', ')}`,
        }).appendTo(textwrapper);
    })

    // update the pagination count
    $('span#species-result-count').text(specieslist.length);
    $('species-result-total').text(CONFIG.speciescount);

    // update the species searched pills
    updateSpeciesSearchPills()
} // updateSpeciesResults

// wrapper around action pagination, called from both the "Get Actions" button, and the "Apply" button on the map tools
function doActionSearch() {

    // first get all checked checkbox values (but skip the "special" check-all checkboxes)
    let checked_targets = [];
    $('ul.action-filters li.action-choice-toggle input[type=checkbox]:checked:not(.all-actions)').each(function() {
        checked_targets.push(this.value);
    });

    // next, intersect checked targets with targets found in the map search (if any)
    // (the server response is simply _all_ targets in the uploaded shape)
    let intersection;
    if (CONFIG.mapsearch_result) {
        intersection = checked_targets.filter(x => CONFIG.mapsearch_result.includes(x));
    } else {
        intersection = checked_targets;
    }

console.log("checked", checked_targets);
console.log("response", CONFIG.mapsearch_result);
console.log("intersection", intersection);

    // then, filter the raw species list to the response targets
    const species_results = DATA.specieslist.filter(function(sp) {
        return intersection.indexOf(sp.key) > -1;
    }); 

    // Species filtering complete:
    // get the full list of actions from that set of species targets
    let actions = [];
    species_results.forEach(function(sp) {
        sp.actions.forEach(function(action) {
            actions.push(action);
        });
    });
    // call the pagination method on this set of actions
    paginateActionResults(actions);
}


// paginate the action results
function paginateActionResults(actionlist) {
    // first we need to remove "regional" actions so that they are not repeated
    // we can't do this until we know which species to display, as we only remove and group
    // from _this_ set of species, not across all species

    // but first, we have to split the list in two: we do want to remove duplicate regional actions
    // we do not want to remove duplicate species actions
    let species_actions = [], 
    regional_actions = [];
    actionlist.forEach(function(a) {
        if (CONFIG.regional_actions.indexOf(a.targettype) > -1) {
            regional_actions.push(a);
        } else {
            species_actions.push(a);
        }
    });
    // get the unique regional actions
    let unique_regional_actions = uniqueObjects(regional_actions, 'key');
    // and join the list back together
    let actions = species_actions.concat(unique_regional_actions);

    if (! actions.length) {
        // no results
        $('#action-search-no-results').show();
        $('#action-search-results').hide();

    } else {
        // we have results
        $('#action-search-no-results').hide();
        $('#action-search-results').show();

        // sort by type then name
        // type sort is custom according to this array
        // Note: this is really sensitive to missing and misspelled keys! 
        // Note: these sort keys are added to the data in the view
        let order = ['Bird', 'Fish', 'Herp', 'Invertebrate', 'Mammal', 'Plant', 'Other', 'Plant regional', 'Regional', 'Water', 'Amphibian'];

        // reduce this to an object because it will be faster https://stackoverflow.com/a/50028663
        order = order.reduce((r, k, v) => Object.assign(r, { [k]: v }), {});

        // multi-sort by type (in the order specified above), then name, then key
        let actions_sorted = actions.sort((a, b) => 
            (order[a.sortkey] > order[b.sortkey]) ? 1 : 
                (order[a.sortkey] === order[b.sortkey]) ? ((a.commonname > b.commonname) ? 1 :
                    (a.commonname === b.commonname) ? ((a.key > b.key) ? 1 :
                        -1) : -1) : -1);

        // alright then, go ahead and paginate it! 
        $('div#action-pagination').pagination({
            dataSource: actions_sorted,
            pageSize: CONFIG.pagesize,
            callback: function(data, pagination) {
                // send this chunk of data to the render method
                updateActionsResults(data, pagination);
            }
        })
    
        // final step: update the searched-for-species list
        updateActionSearchPills();
    }
}

// update results for actions
// this takes an arbitrary list of species results, i.e. from the pagination control
function updateActionsResults(actions, pagination) {
    let target = $('div#action-cards').empty();
    let action_length = 0;

    // iterate the list and create an action "card" for each species action
    actions.forEach(function(action, i) {
        // increment the counter
        action_length += 1;

        // format the class for the "type" pill
        let pill_type_class = 'species-type-pill';
        // test for blank latinname to distinguish from actual species actions for targettype plant
        if (CONFIG.regional_actions.indexOf(action.targettype) > -1 && action.latinname == '') {
            pill_type_class += ' regional';
        }

        let card = $('<div>', {
            'class': 'card-outer',
        }).appendTo(target);

        let textwrapper = $('<div>', {
            'class': 'card-text-wrapper'
        }).appendTo(card);

        // left side of the card
        let cardleft = $('<div>', {
            'class': 'card-left'
        }).appendTo(textwrapper);

        $('<div>', {
            'class': pill_type_class,
            text: action.targettype,
        }).appendTo(cardleft);

        // conditionally format the common name as a link to a species page
        // yes for regular species actions, no for regional actions (which don't have such a page)
        let commonname_html = action.commonname == 'Regional Action' ? action.commonname : `<a class="targetlink" href="/species/${action.key.split(' ')[0]}">${action.commonname}</a>`;
        $('<div>', {
            'class': 'species-commonname',
            html: commonname_html,
        }).appendTo(cardleft);

        $('<div>', {
            'class': 'species-latinname',
            text: action.latinname,
        }).appendTo(cardleft);
        
        // right side of the card
        let cardright = $('<div>', {
            'class': 'card-right'
        }).appendTo(textwrapper);

        $('<div>', {
            'class': 'goal-pill',
            text: action.goal,
        }).appendTo(cardright);

        $('<div>', {
            'class': 'objective-pill',
            text: action.objective,
        }).appendTo(cardright);

        $('<h3>', {
            'class': 'action-subheader',
            text: action.key
        }).appendTo(cardright);

        $('<p>', {
            text: action.description
        }).appendTo(cardright);

    }); // each action

    // update the pagination counter
    let min = ((pagination.pageNumber - 1) * pagination.pageSize) + 1;
    let max = min - 1 + pagination.pageSize;
    if (max > pagination.totalNumber) max = pagination.totalNumber;
    if (min > max) min = max;
    $('span#action-min').text(min);
    $('span#action-max').text(max);
    $('span#action-total').text(pagination.totalNumber);

} // updateActionResults


// action search: update the "pills" that indicate which species/targets/areas are being searched
function updateActionSearchPills() {
    // scan the labels and get the checked ones text into a list
    let labels = [];
    let checked = $('ul.action-filters li.action-choice-toggle input[type=checkbox]:checked:not(.all-actions)');
    $.each(checked, function() {
        labels.push($(this).next().text().trim());
    });

    // update the pills above the results that indicate what is being searched for
    let searched = $('div.searching-for div#species-searched').empty();
    labels.forEach(function(label) {
        $('<div>', {
            'class':'searched-for-pill',
            text: label,
        }).appendTo(searched);
    });

    // update the "area searched" message
    let searchtext;
    if (CONFIG.mapsearch_result) {
        searchtext = 'Drawn/uploaded polygon';
    } else {
        searchtext = 'Entire study area';
    }
    $('div#action-area-searched').text(searchtext);
}

// species search: update the "pills" that indicate which species/targets/areas are being searched
function updateSpeciesSearchPills() {
    // update the "area searched" message
    let searchtext;
    if (CONFIG.mapsearch_result) {
        searchtext = 'Drawn/uploaded polygon';
    } else {
        searchtext = 'Entire study area';
    }
    $('div#species-area-searched').text(searchtext);
}

///////////////////////////////////////////////////////////////////////////////////////////////////////////
// shims and utilities
///////////////////////////////////////////////////////////////////////////////////////////////////////////

// get a unique set of objects from an array by key
function uniqueObjects(array, propertyName) {
   return array.filter((e, i) => array.findIndex(a => a[propertyName] === e[propertyName]) === i);
}

// wait for a variable to exist. When it does, fire the given callback
function waitForIt(key, callback) {
    if (key) {
        callback();
    } else {
        setTimeout(function() {
            waitForIt(key, callback);
        }, 100);
    }
};
